package ru.it_mozaika.sender.js.application.frames.properties

import io.ktor.client.request.*
import io.ktor.http.*
import js.core.jso
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.TypographyVariant
import mui.material.styles.useTheme
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.events.ChangeEvent
import react.dom.onChange
import ru.it_mozaika.components.AvatarButton
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.components.useSnackbar
import ru.it_mozaika.sender.common.models.Property
import ru.it_mozaika.sender.common.models.PropertyType
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.components.properties.propertiesDeleteDialog
import ru.it_mozaika.sender.js.application.context.PropertiesContext
import ru.it_mozaika.sender.js.application.context.useBackdrop
import ru.it_mozaika.sender.js.application.context.useStore
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.ColumnDef
import tanstack.table.core.ColumnDefTemplate
import tanstack.table.core.StringOrTemplateHeader
import tanstack.table.core.getCoreRowModel
import web.cssom.*
import web.html.HTMLInputElement


val propertyTypeTitles = mapOf(
    PropertyType.String to "Строка",
    PropertyType.Int to "Целое число",
    PropertyType.Float to "Число с точкой",
    PropertyType.Date to "Дата / Время",
    PropertyType.Bool to "Да / Нет",
)
private val tableColumns = listOf("id" to "ID", "name" to "Название", "variable" to "Переменная", "type" to "Тип поля", "multiValued" to "Множественное")
val PropertiesFrame = VFC {
    val store = useStore().currentStoreId
    val propertiesContext = useContext(PropertiesContext)
    val properties = propertiesContext.propertiesList
    var editProperty by useState<Property>()
    val (selectedProperties, setSelectedProperties) = useState<List<Property>>(listOf())
    val (showDeleteDialog, setShowDeleteDialog) = useState(false)
    useEffect(store) { propertiesContext.updatePropertiesList() }
    EditPropertyDialog {
        property = editProperty
        onClose = {
            editProperty = null
            if (it) {
                propertiesContext.updatePropertiesList()
            }
        }
    }
    propertiesDeleteDialog {
        isOpen = showDeleteDialog
        onClose = {
            setSelectedProperties(listOf())
            setShowDeleteDialog(false)
            propertiesContext.updatePropertiesList()
        }
        selected = selectedProperties
    }
    val table = useReactTable<Property>(
        options = jso {
            this.columns = useMemo(tableColumns) {
                tableColumns.map { (column, title) ->
                    jso<ColumnDef<Property, Any?>> {
                        accessorFn = { item, _ ->
                            when (column) {
                                "id" -> item.id
                                "name" -> item.name
                                "variable" -> item.variable
                                "type" -> propertyTypeTitles[item.type] ?: "Неизвестный тип поля"
                                "multiValued" -> item.multiValued
                                else -> ""
                            }
                        }
                        cell = ColumnDefTemplate { context ->
                            val value = context.getValue()
                            Box.create {
                                if (context.column.id == "multiValued") {
                                    FormControlLabel {
                                        checked = value as Boolean
                                        control = Checkbox.create()
                                        label = ReactNode(
                                            if (value) {
                                                "Да"
                                            } else {
                                                "Нет"
                                            }
                                        )
                                    }
                                } else {
                                    +(value as String)
                                }
                            }
                        }
                        id = column
                        header = StringOrTemplateHeader(title)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(properties) { properties.toTypedArray() }
            this.state = jso {}
            this.onColumnVisibilityChange = {}
            this.onColumnOrderChange = {}
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = false
            this.debugHeaders = true
            this.debugColumns = true
        }
    )
    MainCard {
        CardHeader{
            title = Stack.create{
                this.direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Typography{
                    variant = TypographyVariant.h2
                    + "Пользовательские поля"
                }
                StoresSelect()
            }
            this.action = Stack.create {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                spacing = responsive(2)
                sx {
                    this.width = 100.pct
                    this.border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                AvatarButton {
                    this.tooltipTitle = "Добавить пользовательское поле"
                    onClick = { editProperty = Property("", store.orEmpty(), "Новое пользовательское поле", "") }
                    mui.icons.material.AddCircleOutlineSharp()
                }
            }
        }

//        Toolbar {
//            sx {
//                display = Display.flex
//                flexWrap = FlexWrap.wrap
//                paddingTop = 7.px
//            }
//            Stack {
//                this.direction = responsive(StackDirection.row)
//                this.divider = Divider.create {
//                    orientation = Orientation.vertical
//                }
//                asDynamic().spacing = 2
//                sx {
//                    this.width = 100.pct
//                    border = 2.px
//                    this.alignItems = AlignItems.center
//                    this.justifyContent = JustifyContent.flexStart
//                }
//
//            }
//        }
        commonTableSkeletonFrame {
            toolbarActions = Stack.create {
                this.direction = responsive(StackDirection.row)
                spacing = responsive(2)
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                if (selectedProperties.isNotEmpty()) {
                    AvatarButton {
                        onClick = {
                            setShowDeleteDialog(true)
                        }
                        tooltipTitle = "Удалить свойства"
                        palettecolor =  useTheme<Theme>().palette.error
                        mui.icons.material.DeleteForeverSharp()
                    }
                }
            }
            this.showCheckBox = true
            this.table = table
            this.onPropertySelect = {
            }
            this.columnId = "id"
            this.label = "properties"
            this.onDoubleClickHandler = { id ->
                editProperty = properties.find { it.id == id }
            }
            this.onSelectionChanged = { selected ->
                val newList = selected.mapNotNull { id ->
                    properties.find { it.id == id }
                }
                setSelectedProperties(newList)
            }
        }
    }
}

external interface EditPropertyDialogProps : Props {
    var property: Property?
    var onClose: (Boolean) -> Unit
}
val EditPropertyDialog = FC<EditPropertyDialogProps> { props ->
    val backdrop = useBackdrop()
    val showNotification = useSnackbar().enqueueSnackbar
    val store = useStore().currentStoreId
    val (property, setProperty) = useState(Property("", store.orEmpty(), "", ""))
    useEffect(props.property) {
        props.property?.let { setProperty(it.copy()) }
    }
    Dialog {
        open = null != props.property
        onClose = { _, _ -> props.onClose(false) }
        fullWidth = true
        maxWidth = "sm"
        DialogTitle { +if (!props.property?.id.isNullOrBlank()) "Редактирование поля ${props.property?.name}" else "Созданиие нового поля" }
        DialogContent {
            Stack {
                direction = responsive(StackDirection.column)
                spacing = responsive(2)
                sx { marginTop = 16.px }
                TextField {
                    id = "property-field-name"
                    label = ReactNode("Название поля")
                    variant = FormControlVariant.outlined
                    fullWidth = true
                    value = property.name
                    error = property.name.isBlank() || property.name == "Новое пользовательское поле"
                    required = true
                    onChange = { e ->
                        setProperty {
                            it.copy(name = e.unsafeCast<ChangeEvent<HTMLInputElement>>().target.value)
                        }
                    }
                }
                TextField {
                    id = "property-field-variable"
                    label = ReactNode("Переменная для подстановки")
                    variant = FormControlVariant.outlined
                    fullWidth = true
                    value = property.variable
                    error = property.variable.isBlank()
                    required = true
                    onChange = { e ->
                        setProperty {
                            it.copy(variable = e.unsafeCast<ChangeEvent<HTMLInputElement>>().target.value)
                        }
                    }
                }
                StoresSelect()
                Select {
                    id = "property-field-type"
                    labelId = "property-field-type-label"
                    label = ReactNode("Тип поля")
                    InputLabel {
                        +"Тип поля"
                    }
                    variant = SelectVariant.outlined
                    fullWidth = true
                    value = property.type
                    required = true
                    renderValue = {
                        ReactNode(propertyTypeTitles[(it as PropertyType)] ?: "Неизвестный тип поля")
                    }
                    onChange = { e, _ ->
                        val value = e.target.value.unsafeCast<PropertyType>()
                        setProperty {
                            it.copy(type = value)
                        }
                    }
                    PropertyType.values().forEach {
                        MenuItem {
                            value = it
                            +(propertyTypeTitles[it] ?: "Неизвестный тип поля")
                        }
                    }
                }
                Select {
                    id = "property-field-multi-valued"
                    labelId = "property-field-multi-valued-label"
                    label = ReactNode("Множественное")
                    variant = SelectVariant.outlined
                    fullWidth = true
                    value = property.multiValued
                    required = true
                    InputLabel {
                        +"Множественное значение"
                    }
                    onChange = { e, _ ->
                        val value = e.target.value.unsafeCast<Boolean>()
                        setProperty {
                            it.copy(multiValued = value)
                        }
                    }
                    MenuItem {
                        value = true
                        +"Да"
                    }
                    MenuItem {
                        value = false
                        +"Нет"
                    }
                }
            }
        }
        DialogActions {
            Button {
                onClick = { props.onClose(false) }
                autoFocus = true
                variant = ButtonVariant.outlined
                color = ButtonColor.error
                +"Назад"
            }
            Button {
                onClick = {
                    if (props.property?.id.isNullOrBlank()) {
                        Http.put("/subscribers/properties", property, {
                            contentType(ContentType.Application.Json)
                            parameter("store", store.orEmpty())
                        }) { response ->
                            backdrop.hide()
                            response.checkResponseError()?.let {
                                showNotification(it, jso { variant = AlertColor.error })
                                return@put
                            }
                            props.onClose(true)
                        }
                    } else {
                        Http.post(
                            "/subscribers/properties/${props.property?.id}",
                            property,
                            query = mapOf("store" to store.orEmpty())
                        ) { response ->
                            backdrop.hide()
                            response.checkResponseError()?.let {
                                showNotification(it, jso { variant = AlertColor.error })
                                return@post
                            }
                            props.onClose(true)
                        }
                    }
                }
                variant = ButtonVariant.outlined
                color = ButtonColor.secondary
                endIcon = mui.icons.material.Save.create()
                disabled = (
                        (!props.property?.id.isNullOrBlank() && props.property == property)
                                || property.name.isBlank()
                                || property.variable.isBlank()
                                || property.name == "Новое пользовательское поле"

                        )
                +"Сохранить"
            }
        }
    }
}